/* eslint-disable react/display-name */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React from 'react';

export default () => (
    <img className="handleGrab" aria-hidden="true" src="/icons/querybuilder/Resting.svg" style={{color: 'white'}} alt="" />
);
